module.exports = __webpack_public_path__ + "static/media/telepules-rekonstrukcio-kivitelezes.be650bd9.jpg";